<!-- Broadband label for tablet start -->
<div class="main-broadband-section" *ngIf="labelResponse?.length && !isGrandFatheredLabel">
    <div class="broadband-desktop-view">
        <xm-fcc-card page="line-details-cbm">
            <xm-broadband-header [cbmLabelContent]="cbmLabelContent"></xm-broadband-header>
            <div class="broadband-main-label">
                <cbm-nutrition-label
                    class="fcc-label column-{{labelResponse?.length}}"
                    *ngFor="let label of labelResponse"
                    [ngClass]="{ 'active-label': activeTabPlanId === label?.planId }"
                    [isInUse]="activePlanId === label?.planId"
                    [response]="label"
                    [isLineDetailsBBL]="true">
                </cbm-nutrition-label>
            </div>
        </xm-fcc-card>
    </div>
</div>
<!-- Broadband banner for Grand father for smart watches start -->
<div class="header-section" *ngIf="isGrandFatheredLabel">
    <xm-broadband-header [cbmLabelContent]="cbmLabelContent" [isGrandFatheredLabel]="isGrandFatheredLabel" [infoIconGrey]="infoIconGrey"></xm-broadband-header>
</div>
<!-- Broadband banner for Grand father for smart watches end -->

